import {uploadFile} from './direct_upload';


//
//Edit時はカテゴリの変更をdisabledにしておく
//
$(document).ready(() => {
  const isEditPage = location.pathname.match(/\/merchandise\/\d+/);

  if (isEditPage) {
    $("input:radio[name='category'], input:radio[name='subcategory']").prop('disabled', true);
  }
});

$(function () {
  $('.directUpload').find("input:file").each(function (i, elem) {
    var fileInput = $(elem);
    var form = $(fileInput.parents('form:first'));
    var submitButton = form.find('input[type="submit"]');
    var progressBar = $("<div class='bar'></div>");
    var barContainer = $("<div class='progress'></div>").append(progressBar);
    fileInput.after(barContainer);
    fileInput.fileupload({
      fileInput: fileInput,
      url: form.data('url'),
      type: 'POST',
      autoUpload: true,
      formData: form.data('form-data'),
      paramName: 'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
      dataType: 'XML',  // S3 returns XML if success_action_status is set to 201
      replaceFileInput: false,
      progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        progressBar.css('width', progress + '%')
      },
      start: function (e) {
        submitButton.prop('disabled', true);

        progressBar.css('background', 'green').css('display', 'block').css('width', '0%').text("Loading...");
      },
      done: function (e, data) {
        submitButton.prop('disabled', false);
        progressBar.text("Uploading done");

        // extract key and generate URL from response
        var key = $(data.jqXHR.responseXML).find("Key").text();
        var url = '//' + form.data('host') + '/' + key;

        // create hidden field
        var input = $("<input />", {type: 'hidden', name: fileInput.attr('name'), value: url})
        form.append(input);
      },
      fail: function (e, data) {
        submitButton.prop('disabled', false);

        progressBar.css("background", "red").text("Failed");
      }
    });
  });
});

//イメージ削除
$(document).on('click', ".fa-times", function () {
  let id = $(this).parents('li').data('id')
  if (id) {
    $(this).parents('li').remove()
  }
  $.ajax({
    url: '/dashboard/merchandise/draft_image_delete',
    type: 'post',
    dataType: 'json',
    data: {id: id},
    context: this
  })
      .done(function (res) {
      })
      .fail(function (jqXHR, statusText, errorThrown) {
      });
})


$(document).on('change', '#file-merchandise', function () {
  $(this).prop('disabled', true)

  $("#file_error").html("")
  let files = $("#file-merchandise")[0].files

  let image_limit = parseInt($('#file-merchandise').closest('tr').data('image-limit')) || 30 ;

  let registered_image = ($('.current-registered-image').length)

  if (registered_image + files.length > image_limit) {
    $("#file_error").html(`※アップロード可能なファイルは${image_limit}枚までです`).css('color', 'red')
    $('#file-merchandise').val(null)
    $(this).prop('disabled', false)
    return
  }
  for (let i = 0; i < files.length; i++) {
    let extension_type = ["image/jpeg", "image/png", "image/jpg"]
    if (!extension_type.includes(files[i]['type'])) {
      $("#file_error").html("※登録可能形式は、jpeg, jpg, pngのみです。").css('color', 'red')
      $(this).css('border: solid 2px red')
      $('#file-merchandise').val(null)
      $(this).prop('disabled', false)
      return
    }
    if (files[i]['size'] > 5242880) {
      $("#file_error").html("※5MB以上のファイルが含まれています。ファイルサイズは5MB以下のみ選択可能です").css('color', 'red')
      $(this).css('border: solid 2px red')
      $('#file-merchandise').val(null)
      $(this).prop('disabled', false)
      return
    }
  }

  let deferred = (new $.Deferred()).resolve();
  $("#file_error").html('<i class="fas fa-circle-notch fa-spin loading-spin"></i>').css('color', 'black')
  $.each(this.files, function (i, file) {
    let merchandise_id = location.href.match(/merchandise\/(\d+)/)
    merchandise_id = merchandise_id ? merchandise_id[1] : null
    console.log(merchandise_id)
    deferred = deferred.then(uploadFile(merchandise_id, file, '/dashboard/merchandise/merchandise_images', '#file-merchandise'));
  })

  deferred.then(function () {
    $("#file_error").html('')
    $('#file-merchandise').val(null).prop('disabled', false)
  });
})

//
//出品者コメントの文字色・太字・文字サイズ装飾とプレビュー
//
const SELLER_COMMENT_FORMATS = ['sc-red', 'sc-black', 'sc-bold', 'sc-normal', 'sc-small', 'sc-large', 'sc-xlarge'];

const escapeHtml = (text) => $('<div>').text(text).html();

const renderSellerCommentPreview = (text) => {
  const pattern = new RegExp(`&lt;span class="(${SELLER_COMMENT_FORMATS.join('|')})"&gt;`, 'g');
  return escapeHtml(text)
    .replace(/&quot;/g, '"')
    .replace(pattern, '<span class="$1">')
    .replace(/&lt;\/span&gt;/g, '</span>')
    .replace(/\r?\n/g, '<br>');
};

$(function () {
  const $input = $('.seller-comment-input');
  const $preview = $('.seller-comment-preview');
  if (!$input.length) return;

  const updatePreview = () => $preview.html(renderSellerCommentPreview($input.val() || ''));

  $('.seller-comment-format').on('click', function () {
    const format = $(this).data('format');
    const textarea = $input.get(0);
    const value = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const openTag = `<span class="${format}">`;
    const closeTag = '</span>';

    textarea.value = value.slice(0, start) + openTag + value.slice(start, end) + closeTag + value.slice(end);
    textarea.focus();
    textarea.setSelectionRange(start + openTag.length, end + openTag.length);
    updatePreview();
  });

  $input.on('input', updatePreview);
  updatePreview();
});
